import { render, staticRenderFns } from "./IntroSection.vue?vue&type=template&id=61d15477&scoped=true"
import script from "./IntroSection.vue?vue&type=script&lang=js"
export * from "./IntroSection.vue?vue&type=script&lang=js"
import style0 from "./IntroSection.vue?vue&type=style&index=0&id=61d15477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d15477",
  null
  
)

export default component.exports